import { tabsHandler, swiperInit, grubScrolling } from './helper'

swiperInit({
  perView: 1.3,
  className: '.project-list-slider',
  nextBtnClass: '.project-list-slider__btn--right',
  prevBtnClass: '.project-list-slider__btn--left',
  spaceBetween: 0,
  loop: false,
  breakpoints: {
    1025: {
      slidesPerView: 3.2,
      spaceBetween: 0,
    }
  },
})

tabsHandler({
  wrapClass: 'project-tab',
  activeTrigger: 'project-tab__head--active',
  activeTarget: 'project-tab__item--active'
})

grubScrolling('.project-tab__heads')